type ModalCallback = (() => void) | (() => Promise<void>);

export const useConfirmModal = () => {
  const show = useState('modal', () => false);
  const loadingConfirm = useState('modal-loading-confirm', () => false);
  const loadingCancel = useState('modal-loading-cancel', () => false);
  const descriptionText = useState<string | undefined>('modal-description');
  const confirmCallback = useState<ModalCallback | undefined>('modal-confirm-callback');
  const cancelCallback = useState<ModalCallback | undefined>('modal-cancel-callback');

  const cancel = async () => {
    loadingCancel.value = cancelCallback.value?.constructor.name === 'AsyncFunction';
    try {
      await cancelCallback.value?.();
    }
    finally {
      show.value = false;
      loadingCancel.value = false;
    }
  };

  const confirm = async () => {
    loadingConfirm.value = confirmCallback.value?.constructor.name === 'AsyncFunction';
    try {
      await confirmCallback.value?.();
    }
    finally {
      show.value = false;
      loadingConfirm.value = false;
    }
  };

  const onConfirm = (fn: ModalCallback) => (confirmCallback.value = fn);
  const onCancel = (fn: ModalCallback) => (cancelCallback.value = fn);

  const reveal = (description?: string) => {
    descriptionText.value = description;
    show.value = true;
  };

  return {
    show,
    reveal,
    cancel,
    confirm,
    onCancel,
    onConfirm,
    loadingCancel: readonly(loadingCancel),
    loadingConfirm: readonly(loadingConfirm),
    descriptionText: readonly(descriptionText),
  };
};
